{
  "about.blocks": "Rajekarên çavdêrkirî",
  "about.contact": "Têkilî:",
  "about.default_locale": "Berdest",
  "about.disclaimer": "Mastodon belaş e, nermalaveke çavkaniya vekirî ye û markeyeke Mastodon gGmbHê ye.",
  "about.domain_blocks.no_reason_available": "Sedem ne berdest e",
  "about.domain_blocks.preamble": "Mastodon bi gelemperî dihêle ku tu naverokê bibînî û bi bikarhênerên ji rajekareke din a li fendiverse re têkilî dayne. Ev awaretyên ku li ser vê rajekara taybetî hatine çêkirin ev in.",
  "about.domain_blocks.silenced.explanation": "Heye ku tu bi awayekî vekirî lê negerî an jî bi şopandinê hilnebijêrî, tu yêbi giştî profîl û naverok ji vê rajekarê nebînî.",
  "about.domain_blocks.silenced.title": "Sînorkirî",
  "about.domain_blocks.suspended.explanation": "Dê tu daneya ji van rajekaran neyê berhev kirin, tomarkirin an jî guhertin, ku têkilî an danûstendinek bi bikarhênerên van rajekaran re tune dike.",
  "about.domain_blocks.suspended.title": "Hatiye rawestandin",
  "about.language_label": "Ziman",
  "about.not_available": "Ev zanyarî li ser vê rajekarê nehatine peydakirin.",
  "about.powered_by": "Medyaya civakî ya nenavendî bi hêzdariya {mastodon}",
  "about.rules": "Rêbazên rajekar",
  "account.account_note_header": "Nîşeyên kesane",
  "account.activity": "Çalakî",
  "account.add_or_remove_from_list": "Li lîsteyan zêde bike yan jî rake",
  "account.badges.bot": "Bot",
  "account.badges.group": "Kom",
  "account.block": "@{name} asteng bike",
  "account.block_domain": "Navpera {domain} asteng bike",
  "account.block_short": "Asteng bike",
  "account.blocked": "Astengkirî",
  "account.cancel_follow_request": "Daxwaza şopandinê vekişîne",
  "account.copy": "Girêdanê bo profîlê jê bigire",
  "account.direct": "Bi taybetî qale @{name} bike",
  "account.disable_notifications": "Êdî min agahdar neke gava @{name} diweşîne",
  "account.edit_profile": "Profîlê serrast bike",
  "account.edit_profile_short": "Serrast bike",
  "account.enable_notifications": "Min agahdar bike gava @{name} diweşîne",
  "account.endorse": "Taybetiyên li ser profîl",
  "account.featured.accounts": "Profîl",
  "account.filters.posts_only": "Şandî",
  "account.filters.posts_replies": "Şandî û bersiv",
  "account.filters.replies_toggle": "Bersivan nîşan bide",
  "account.follow": "Bişopîne",
  "account.follow_back": "Bişopîne",
  "account.follow_back_short": "Bişopîne",
  "account.follow_request": "Bo şopandinê daxwaz bike",
  "account.follow_request_cancel": "Daxwazê têk bibe",
  "account.follow_request_cancel_short": "Têk bibe",
  "account.follow_request_short": "Daxwaz bike",
  "account.followers": "Şopîner",
  "account.followers.empty": "Kesekî hin ev bikarhêner neşopandiye.",
  "account.followers_counter": "{count, plural, one {{counter} şopîner} other {{counter} şopîner}}",
  "account.followers_you_know_counter": "{counter} tu nas dikî",
  "account.following": "Dişopîne",
  "account.following_counter": "{count, plural, one {{counter} dişopîne} other {{counter} dişopîne}}",
  "account.follows.empty": "Ev bikarhêner hin kesekî heya niha neşopandiye.",
  "account.follows_you": "Te dişopîne",
  "account.go_to_profile": "Biçe bo profîlê",
  "account.hide_reblogs": "Bilindkirinên ji @{name} veşêre",
  "account.in_memoriam": "Di bîranînê de.",
  "account.joined_short": "Dîroka tevlîbûnê",
  "account.languages": "Zimanên beşdarbûyî biguherîne",
  "account.last_active": "Çalakiya dawî",
  "account.link_verified_on": "Xwedaniya li vê girêdanê di {date} de hatiye kontrolkirin",
  "account.locked_info": "Rewşa vê ajimêrê wek kilîtkirî hatiye sazkirin. Xwediyê ajimêrê, bi destan dinirxîne şopandinê dinirxîne.",
  "account.media": "Medya",
  "account.mention": "Qal @{name} bike",
  "account.menu.add_to_list": "Tevlî lîsteyê bike…",
  "account.menu.block": "Jimarê asteng bike",
  "account.menu.block_domain": "{domain} asteng bike",
  "account.menu.share": "Parve bike…",
  "account.menu.show_reblogs": "Di demnameyê de şandiyên bilindkirî nîşan bide",
  "account.moved_to": "{name} diyar kir ku ajimêra nû ya wan niha ev e:",
  "account.mute": "@{name} bêdeng bike",
  "account.mute_notifications_short": "Agahdariyan bêdeng bike",
  "account.mute_short": "Bêdeng bike",
  "account.muted": "Bêdengkirî",
  "account.mutual": "Hûn hevdû dişopînin",
  "account.no_bio": "Ti danasîn nehatiye tevlîkirin.",
  "account.open_original_page": "Rûpela resen veke",
  "account.posts": "Şandî",
  "account.report": "@{name} ragihîne",
  "account.requested_follow": "{name} dixwaze te bişopîne",
  "account.share": "Profîla @{name} parve bike",
  "account.show_reblogs": "Bilindkirinên ji @{name} nîşan bike",
  "account.statuses_counter": "{count, plural,one {{counter} şandî}other {{counter} şandî}}",
  "account.unblock": "Astengê li ser @{name} rake",
  "account.unblock_domain": "Astengê li ser navperê {domain} rake",
  "account.unblock_domain_short": "Astengiyê rake",
  "account.unblock_short": "Astengiyê rake",
  "account.unendorse": "Li ser profîl nîşan neke",
  "account.unfollow": "Neşopîne",
  "account.unmute": "@{name} bêdeng neke",
  "account.unmute_notifications_short": "Agahdariyan bêdeng bike",
  "account.unmute_short": "Bêdeng neke",
  "account_note.placeholder": "Bitikîne bo nîşeyekê tevlî bikî",
  "admin.dashboard.daily_retention": "Rêjeya ragirtina bikarhêner bi roj piştî tomarkirinê",
  "admin.dashboard.monthly_retention": "Rêjeya ragirtina bikarhêner bi meh piştî tomarkirinê",
  "admin.dashboard.retention.average": "Navîn",
  "admin.dashboard.retention.cohort": "Meha tomarkirinê",
  "admin.dashboard.retention.cohort_size": "Bikarhênerên nû",
  "alert.rate_limited.message": "Jkx dîsa biceribîne piştî {retry_time, time, medium}.\n \n",
  "alert.rate_limited.title": "Rêje sînorkirî ye",
  "alert.unexpected.message": "Çewtiyeke bêhêvî çê bû.",
  "alert.unexpected.title": "Wey li min!",
  "alt_text_modal.cancel": "Têk bibe",
  "alt_text_modal.change_thumbnail": "Wêneyê biçûk biguherîne",
  "alt_text_modal.done": "Qediya",
  "announcement.announcement": "Daxuyanî",
  "annual_report.summary.new_posts.new_posts": "şandiyên nû",
  "attachments_list.unprocessed": "(bêpêvajo)",
  "audio.hide": "Dengê veşêre",
  "block_modal.show_less": "Kêmtir nîşan bide",
  "block_modal.show_more": "Bêtir nîşan bide",
  "block_modal.title": "Bikarhêner asteng bike?",
  "boost_modal.combo": "Ji bo derbas bî carekî din de pêlê {combo} bike",
  "bundle_column_error.copy_stacktrace": "Rapora çewtiyê jê bigire",
  "bundle_column_error.error.body": "Rûpela xwestî nehate pêşkêşkirin. Dibe ku ew ji ber şaşetiyeke koda me, an jî pirsgirêkeke lihevhatina gerokê be.",
  "bundle_column_error.error.title": "Ax, na!",
  "bundle_column_error.network.body": "Di dema hewldana barkirina vê rûpelê de çewtiyek derket. Ev dibe ku ji ber pirsgirêkeke demkî ya girêdana înternetê te be an jî ev rajekar be.",
  "bundle_column_error.network.title": "Çewtiya torê",
  "bundle_column_error.retry": "Dîsa biceribîne",
  "bundle_column_error.return": "Vegere rûpela sereke",
  "bundle_column_error.routing.body": "Rûpela xwestî nehate dîtin. Tu pê bawerî ku girêdana di darika navnîşanê de rast e?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Bigire",
  "bundle_modal_error.retry": "Dîsa bicerbîne",
  "closed_registrations.other_server_instructions": "Ji ber ku Mastodon nenavendî ye, tu dika li ser rajekarek din ajimêrekê biafirînî û hîn jî bi vê yekê re tev bigerî.",
  "closed_registrations_modal.description": "Afirandina ajimêrekê li ser {domain} niha ne pêkan e, lê ji kerema xwe ji bîr neke ku pêdiviya te bi hebûna ajimêreke taybet li ser {domain} tune ye ku tu Mastodon bi kar bînî.",
  "closed_registrations_modal.find_another_server": "Rajekareke din bibîne",
  "closed_registrations_modal.preamble": "Mastodon nenavendî ye, ji ber vê yekê tu li ku derê ajimêrê xwe biafirînê, tu yê bikaribî li ser vê rajekarê her kesî bişopînî û têkilî deynî. Her wiha tu dikarî wê bi xwe pêşkêş bikî!",
  "closed_registrations_modal.title": "Tomar bibe li ser Mastodon",
  "column.about": "Derbar",
  "column.blocks": "Bikarhênerên astengkirî",
  "column.bookmarks": "Şûnpel",
  "column.community": "Demnameya herêmî",
  "column.direct": "Payemên taybet",
  "column.directory": "Li profîlan bigere",
  "column.domain_blocks": "Navperên astengkirî",
  "column.firehose": "Rojevên zindî",
  "column.follow_requests": "Daxwazên şopandinê",
  "column.home": "Rûpela sereke",
  "column.lists": "Lîste",
  "column.mutes": "Bikarhênerên bêdengkirî",
  "column.notifications": "Agahdarî",
  "column.pins": "Şandiya derzîkirî",
  "column.public": "Demnameya giştî",
  "column_back_button.label": "Vegere",
  "column_header.hide_settings": "Sazkariyan veşêre",
  "column_header.moveLeft_settings": "Stûnê bilivîne bo çepê",
  "column_header.moveRight_settings": "Stûnê bilivîne bo rastê",
  "column_header.pin": "Bi derzî bike",
  "column_header.show_settings": "Sazkariyan nîşan bide",
  "column_header.unpin": "Bi derzî neke",
  "column_search.cancel": "Têk bibe",
  "community.column_settings.local_only": "Tenê herêmî",
  "community.column_settings.media_only": "Tenê media",
  "community.column_settings.remote_only": "Tenê ji dûr ve",
  "compose.language.change": "Ziman biguherîne",
  "compose.language.search": "Li zimanan bigere...",
  "compose_form.direct_message_warning_learn_more": "Bêtir fêr bibe",
  "compose_form.encryption_warning": "Şandiyên li ser Mastodon dawî-bi-dawî ne şîfrekirî ne. Li ser Mastodon zanyariyên hestyar parve neke.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Ajimêrê te ne {locked}. Herkes dikare te bişopîne da ku şandiyên te yên tenê ji şopînerên re têne xuyakirin bibînin.",
  "compose_form.lock_disclaimer.lock": "girtî ye",
  "compose_form.placeholder": "Çi di hişê te derbas dibe?",
  "compose_form.poll.duration": "Dema rapirsî yê",
  "compose_form.poll.switch_to_multiple": "Rapirsî yê biguherînin da ku destûr bidin vebijarkên pirjimar",
  "compose_form.poll.switch_to_single": "Rapirsîyê biguherîne da ku mafê bidî tenê vebijêrkek",
  "compose_form.poll.type": "Şêwaz",
  "compose_form.publish": "Şandî",
  "compose_form.reply": "Bersivê bide",
  "compose_form.save_changes": "Rojane bike",
  "compose_form.spoiler.marked": "Hişyariya naverokê rake",
  "compose_form.spoiler.unmarked": "Hişyariya naverokê tevlî bike",
  "confirmation_modal.cancel": "Dev jê berde",
  "confirmations.block.confirm": "Asteng bike",
  "confirmations.delete.confirm": "Jê bibe",
  "confirmations.delete.message": "Ma tu dixwazî vê şandiyê jê bibî?",
  "confirmations.delete.title": "Şandiyê jê bibe?",
  "confirmations.delete_list.confirm": "Jê bibe",
  "confirmations.delete_list.message": "Tu ji dil dixwazî vê lîsteyê bi awayekî mayînde jê bibî?",
  "confirmations.discard_edit_media.confirm": "Biavêje",
  "confirmations.discard_edit_media.message": "Guhertinên neqedandî di danasîna an pêşdîtina medyayê de hene, wan bi her awayî bavêje?",
  "confirmations.logout.confirm": "Derkeve",
  "confirmations.logout.message": "Ma tu dixwazî ku derkevî?",
  "confirmations.mute.confirm": "Bêdeng bike",
  "confirmations.redraft.confirm": "Jê bibe & ji nû ve serrast bike",
  "confirmations.redraft.message": "Bi rastî tu dixwazî şandî ye jê bibî û ji nû ve reşnivîsek çê bikî? Bijarte û şandî wê wenda bibin û bersivên ji bo şandiyê resen wê sêwî bimînin.",
  "confirmations.unfollow.confirm": "Neşopîne",
  "content_warning.show_more": "Bêtir nîşan bide",
  "conversation.delete": "Axaftinê jê bibe",
  "conversation.mark_as_read": "Wekî xwendî nîşan bide",
  "conversation.open": "Axaftinê nîşan bide",
  "conversation.with": "Bi {names} re",
  "copypaste.copied": "Hate jêgirtin",
  "directory.federated": "Ji fediversên naskirî",
  "directory.local": "Tenê ji {domain}",
  "directory.new_arrivals": "Kesên ku nû hatine",
  "directory.recently_active": "Di demên dawî de çalak",
  "disabled_account_banner.account_settings": "Sazkariyên ajimêr",
  "disabled_account_banner.text": "Ajimêrê te {disabledAccount} niha neçalak e.",
  "dismissable_banner.community_timeline": "Ev şandiyên giştî yên herî dawî ji kesên ku ajimêrê wan ji aliyê {domain} ve têne pêşkêşkirin.",
  "dismissable_banner.dismiss": "Paşguh bike",
  "domain_block_modal.block": "Rajekar asteng bike",
  "domain_pill.server": "Rajekar",
  "domain_pill.username": "Navê bikarhêner",
  "embed.instructions": "Bi jêgirtina koda jêrîn vê şandiyê li ser malpera xwe bi cih bike.",
  "embed.preview": "Ew ê çawa xuya bibe li vir tê nîşandan:",
  "emoji_button.activity": "Çalakî",
  "emoji_button.clear": "Pak bike",
  "emoji_button.custom": "Kesanekirî",
  "emoji_button.flags": "Al",
  "emoji_button.food": "Xwarin û vexwarin",
  "emoji_button.label": "Emoji têxe",
  "emoji_button.nature": "Sirûştî",
  "emoji_button.not_found": "Hestokên lihevhatî nehate dîtin",
  "emoji_button.objects": "Tişt",
  "emoji_button.people": "Mirov",
  "emoji_button.recent": "Pir caran tê bikaranîn",
  "emoji_button.search": "Bigere...",
  "emoji_button.search_results": "Encamên lêgerînê",
  "emoji_button.symbols": "Sembol",
  "emoji_button.travel": "Geşt û şûn",
  "empty_column.account_suspended": "Ajimêr hatiye rawestandin",
  "empty_column.account_timeline": "Li vir şandî tune!",
  "empty_column.account_unavailable": "Profîl nayê peydakirin",
  "empty_column.blocks": "Te tu bikarhêner asteng nekiriye.",
  "empty_column.bookmarked_statuses": "Hîn tu peyamên te yên şûnpelkirî tune ne. Dema ku tu yekî şûnpel bikî, ew ê li vir xuya bibe.",
  "empty_column.community": "Demnameya herêmî vala ye. Tiştek ji raya giştî re binivsînin da ku rûpel biherike!",
  "empty_column.domain_blocks": "Hîn tu navperên ku hatine astengkirin tune ne.",
  "empty_column.explore_statuses": "Tiştek niha di rojevê de tune. Paşê vegere!",
  "empty_column.follow_requests": "Hê jî daxwaza şopandinê tunne ye. Dema daxwazek hat, yê li vir were nîşan kirin.",
  "empty_column.hashtag": "Di vê hashtagê de hêj tiştekî tune.",
  "empty_column.home": "Rojeva demnameya te vala ye! Bo tijîkirina wê bêtir mirovan bişopîne.",
  "empty_column.list": "Di vê rêzokê de hîn tiştek tune ye. Gava ku endamên vê rêzokê peyamên nû biweşînin, ew ê li vir xuya bibin.",
  "empty_column.mutes": "Te tu bikarhêner bêdeng nekiriye.",
  "empty_column.notifications": "Hêj hişyariyên te tunene. Dema ku mirovên din bi we re têkilî danîn, hûn ê wê li vir bibînin.",
  "empty_column.public": "Li vir tiştekî tuneye! Ji raya giştî re tiştekî binivîsîne, an ji bo tijîkirinê ji rajekerên din bikarhêneran bi destan bişopînin",
  "error.unexpected_crash.explanation": "Ji ber xeletîyeke di koda me da an jî ji ber mijara lihevhatina gerokan, ev rûpel rast nehat nîşandan.",
  "error.unexpected_crash.explanation_addons": "Ev rûpel bi awayekî rast nehat nîşandan. Ev çewtî mimkûn e ji ber lêzêdekirina gerokan an jî amûrên wergera xweberî pêk tê.",
  "error.unexpected_crash.next_steps": "Nûkirina rûpelê biceribîne. Ku ev bi kêr neyê, dibe ku te hîn jî bi riya gerokeke cuda an jî sepana xwecîhî ya Mastodon bi kar bînî.",
  "error.unexpected_crash.next_steps_addons": "Neçalakkirin û nûkirina rûpelê biceribîne. Ku ev bi kêr neyê, dibe ku te hîn jî bi riya gerokeke cuda an jî sepana xwecihî ya Mastodon bi kar bînî.",
  "errors.unexpected_crash.copy_stacktrace": "Şopa gemara (stacktrace) tûrikê ra jê bigire",
  "errors.unexpected_crash.report_issue": "Pirsgirêkekê ragihîne",
  "explore.trending_links": "Nûçe",
  "explore.trending_statuses": "Şandî",
  "explore.trending_tags": "Hashtag",
  "filter_modal.added.context_mismatch_explanation": "Ev beşa parzûnê ji bo naveroka ku te tê de xwe gihandiye vê şandiyê nayê sepandin. Ku tu dixwazî şandî di vê naverokê de jî werê parzûnkirin, divê tu parzûnê biguherînî.",
  "filter_modal.added.context_mismatch_title": "Naverok li hev nagire!",
  "filter_modal.added.expired_explanation": "Ev beşa parzûnê qediya ye, ji bo ku tu bikaribe wê biguherîne divê tu dema qedandinê biguherînî.",
  "filter_modal.added.expired_title": "Dema parzûnê qediya!",
  "filter_modal.added.review_and_configure": "Ji bo nîrxandin û bêtir sazkirina vê beşa parzûnê, biçe {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Sazkariyên parzûnê",
  "filter_modal.added.settings_link": "rûpela sazkariyan",
  "filter_modal.added.short_explanation": "Ev şandî li beşa parzûna jêrîn hate tevlîkirin: {title}.",
  "filter_modal.added.title": "Parzûn tevlî bû!",
  "filter_modal.select_filter.context_mismatch": "di vê naverokê de nayê sepandin",
  "filter_modal.select_filter.expired": "dema wê qediya",
  "filter_modal.select_filter.prompt_new": "Beşa nû: {name}",
  "filter_modal.select_filter.search": "Lê bigere an jî biafirîne",
  "filter_modal.select_filter.subtitle": "Beşeke nû ya heyî bi kar bîne an jî yekî nû biafirîne",
  "filter_modal.select_filter.title": "Vê şandiyê parzûn bike",
  "filter_modal.title.status": "Şandiyekê parzûn bike",
  "firehose.all": "Tevahî",
  "firehose.local": "Ev rajekar",
  "firehose.remote": "Rajekarên din",
  "follow_request.authorize": "Mafê bide",
  "follow_request.reject": "Nepejirîne",
  "follow_requests.unlocked_explanation": "Tevlî ku ajimêra te ne kilît kiriye, karmendên {domain} digotin qey tu dixwazî ku pêşdîtina daxwazên şopandinê bi destan bike.",
  "follow_suggestions.view_all": "Tevahiyan nîşan bide",
  "footer.about": "Derbar",
  "footer.about_this_server": "Derbar",
  "footer.directory": "Pelrêça profîlan",
  "footer.get_app": "Bernameyê bistîne",
  "footer.keyboard_shortcuts": "Kurteriyên klavyeyê",
  "footer.privacy_policy": "Politîka taybetiyê",
  "footer.source_code": "Koda çavkanî nîşan bide",
  "footer.status": "Rewş",
  "generic.saved": "Tomarkirî",
  "getting_started.heading": "Destpêkirin",
  "hashtag.column_header.tag_mode.all": "û {additional}",
  "hashtag.column_header.tag_mode.any": "an {additional}",
  "hashtag.column_header.tag_mode.none": "bêyî {additional}",
  "hashtag.column_settings.select.no_options_message": "Ti pêşniyar nehatin dîtin",
  "hashtag.column_settings.select.placeholder": "Têkeve hashtagê…",
  "hashtag.column_settings.tag_mode.all": "Van hemûyan",
  "hashtag.column_settings.tag_mode.any": "Yek ji van",
  "hashtag.column_settings.tag_mode.none": "Ne yek ji van",
  "hashtag.column_settings.tag_toggle": "Ji bo vê stûnê hin pêvekan tevlî bike",
  "hashtag.follow": "Hashtagê bişopîne",
  "hashtag.unfollow": "Hashtagê neşopîne",
  "home.column_settings.show_reblogs": "Bilindkirinan nîşan bike",
  "home.column_settings.show_replies": "Bersivan nîşan bide",
  "home.hide_announcements": "Reklaman veşêre",
  "home.show_announcements": "Reklaman nîşan bide",
  "interaction_modal.on_another_server": "Li ser rajekareke cuda",
  "interaction_modal.on_this_server": "Li ser ev rajekar",
  "intervals.full.days": "{number, plural, one {# roj} other {# roj}}",
  "intervals.full.hours": "{number, plural, one {# demjimêr} other {# demjimêr}}\n \n",
  "intervals.full.minutes": "{number, plural, one {# xulek} other {# xulek}}",
  "keyboard_shortcuts.back": "Vegere paşê",
  "keyboard_shortcuts.blocked": "Lîsteya bikarhênerên astengkirî veke",
  "keyboard_shortcuts.boost": "Şandiyê bilind bike",
  "keyboard_shortcuts.column": "Stûna balkişandinê",
  "keyboard_shortcuts.compose": "Bal bikşîne cîhê nivîsê/textarea",
  "keyboard_shortcuts.description": "Danasîn",
  "keyboard_shortcuts.down": "Di lîsteyê de dakêşe jêr",
  "keyboard_shortcuts.enter": "Şandiyê veke",
  "keyboard_shortcuts.federated": "Demnameya giştî veke",
  "keyboard_shortcuts.heading": "Kurterêyên klavyeyê",
  "keyboard_shortcuts.home": "Demnameyê veke",
  "keyboard_shortcuts.hotkey": "Kurte bişkok",
  "keyboard_shortcuts.legend": "Vê çîrokê nîşan bike",
  "keyboard_shortcuts.local": "Demnameya herêmî veke",
  "keyboard_shortcuts.mention": "Qala nivîskarî/ê bike",
  "keyboard_shortcuts.muted": "Lîsteya bikarhênerên bêdengkirî veke",
  "keyboard_shortcuts.my_profile": "Profîla xwe veke",
  "keyboard_shortcuts.notifications": "Stûnê agahdariyan veke",
  "keyboard_shortcuts.open_media": "Medya veke",
  "keyboard_shortcuts.pinned": "Şandiyên derzîkirî veke",
  "keyboard_shortcuts.profile": "Profîla nivîskaran veke",
  "keyboard_shortcuts.reply": "Bersivê bide şandiyê",
  "keyboard_shortcuts.requests": "Lîsteya daxwazên şopandinê veke",
  "keyboard_shortcuts.search": "Bal bide şivika lêgerînê",
  "keyboard_shortcuts.spoilers": "Zeviya hişyariya naverokê nîşan bide/veşêre",
  "keyboard_shortcuts.start": "Stûna \"destpêkê\" veke",
  "keyboard_shortcuts.toggle_hidden": "Nivîsa paş hişyariya naverokê nîşan bide/veşêre",
  "keyboard_shortcuts.toggle_sensitivity": "Medyayê nîşan bide/veşêre",
  "keyboard_shortcuts.toot": "Dest bi şandiyeke nû bike",
  "keyboard_shortcuts.unfocus": "Bal nede cîhê nivîsê /lêgerînê",
  "keyboard_shortcuts.up": "Di lîsteyê de rake jor",
  "lightbox.close": "Bigire",
  "lightbox.next": "Pêş",
  "lightbox.previous": "Paş",
  "limited_account_hint.action": "Bi heman awayî profîlê nîşan bide",
  "limited_account_hint.title": "Profîl ji aliyê rêveberên {domain}ê ve hatiye veşartin.",
  "lists.delete": "Lîsteyê jê bibe",
  "lists.edit": "Lîsteyê serrast bike",
  "lists.replies_policy.followed": "Bikarhênereke şopandî",
  "lists.replies_policy.list": "Endamên lîsteyê",
  "lists.replies_policy.none": "Ne yek",
  "load_pending": "{count, plural, one {# hêmaneke nû} other {#hêmaneke nû}}",
  "media_gallery.hide": "Veşêre",
  "moved_to_account_banner.text": "Ajimêrê te {disabledAccount} niha neçalak e ji ber ku te bar kir bo {movedToAccount}.",
  "navigation_bar.about": "Derbar",
  "navigation_bar.blocks": "Bikarhênerên astengkirî",
  "navigation_bar.bookmarks": "Şûnpel",
  "navigation_bar.direct": "Payemên taybet",
  "navigation_bar.domain_blocks": "Navperên astengkirî",
  "navigation_bar.filters": "Peyvên bêdengkirî",
  "navigation_bar.follow_requests": "Daxwazên şopandinê",
  "navigation_bar.followed_tags": "Etîketên şopandî",
  "navigation_bar.follows_and_followers": "Şopandin û şopîner",
  "navigation_bar.lists": "Lîste",
  "navigation_bar.logout": "Derkeve",
  "navigation_bar.mutes": "Bikarhênerên bêdengkirî",
  "navigation_bar.preferences": "Sazkarî",
  "navigation_bar.search": "Bigere",
  "not_signed_in_indicator.not_signed_in": "Divê tu têketinê bikî da ku tu bigihîjî vê çavkaniyê.",
  "notification.admin.report": "{name} hate ragihandin {target}",
  "notification.admin.sign_up": "{name} tomar bû",
  "notification.follow": "{name} te şopand",
  "notification.follow_request": "{name} dixwazê te bişopîne",
  "notification.own_poll": "Rapirsîya te qediya",
  "notification.reblog": "{name} şandiya te bilind kir",
  "notification.status": "{name} niha şand",
  "notification.update": "{name} şandiyek serrast kir",
  "notifications.clear": "Agahdariyan pak bike",
  "notifications.clear_confirmation": "Bi rastî tu dixwazî bi awayekî dawî hemû agahdariyên xwe pak bikî?",
  "notifications.column_settings.admin.report": "Ragihandinên nû:",
  "notifications.column_settings.admin.sign_up": "Tomarkirinên nû:",
  "notifications.column_settings.alert": "Agahdariyên sermaseyê",
  "notifications.column_settings.filter_bar.advanced": "Hemû beşan nîşan bide",
  "notifications.column_settings.follow": "Şopînerên nû:",
  "notifications.column_settings.follow_request": "Daxwazên şopandinê nû:",
  "notifications.column_settings.mention": "Gotin:",
  "notifications.column_settings.poll": "Encamên rapirsiyê:",
  "notifications.column_settings.push": "Agahdarîyên yekser",
  "notifications.column_settings.reblog": "Bilindkirî:",
  "notifications.column_settings.show": "Di nav stûnê de nîşan bike",
  "notifications.column_settings.sound": "Deng lêxe",
  "notifications.column_settings.status": "Şandiyên nû:",
  "notifications.column_settings.unread_notifications.category": "Agahdariyên nexwendî",
  "notifications.column_settings.unread_notifications.highlight": "Agahiyên nexwendî nîşan bike",
  "notifications.column_settings.update": "Serrastkirin:",
  "notifications.filter.all": "Hemû",
  "notifications.filter.boosts": "Bilindkirî",
  "notifications.filter.follows": "Dişopîne",
  "notifications.filter.mentions": "Gotin",
  "notifications.filter.polls": "Encamên rapirsiyê",
  "notifications.filter.statuses": "Ji kesên tu dişopînî re rojanekirin",
  "notifications.grant_permission": "Destûrê bide.",
  "notifications.group": "{count} agahdarî",
  "notifications.mark_as_read": "Hemî agahdarîya wek xwendî nîşan bike",
  "notifications.permission_denied": "Agahdarîyên sermaseyê naxebite ji ber ku berê de daxwazî ya destûr dayîna gerokê hati bû red kirin",
  "notifications.permission_denied_alert": "Agahdarîyên sermaseyê nay çalak kirin, ji ber ku destûr kirina gerokê pêşî de hati bû red kirin",
  "notifications.permission_required": "Agahdarîyên sermaseyê naxebite çunkî mafê pêwîst dike nehatiye dayîn.",
  "notifications_permission_banner.enable": "Agahdarîyên sermaseyê çalak bike",
  "notifications_permission_banner.how_to_control": "Da ku agahdariyên mastodon bistînî gava ne vekirî be. Agahdariyên sermaseyê çalak bike\n Tu dikarî agahdariyên sermaseyê bi rê ve bibî ku bi hemû cureyên çalakiyên ên ku agahdariyan rû didin ku bi riya tikandînê li ser bişkoka {icon} çalak dibe.",
  "notifications_permission_banner.title": "Tu tiştî bîr neke",
  "picture_in_picture.restore": "Vegerîne paş",
  "poll.closed": "Girtî",
  "poll.refresh": "Nû bike",
  "poll.total_people": "{count, plural, one {# kes} other {# kes}}",
  "poll.total_votes": "{count, plural, one {# deng} other {# deng}}",
  "poll.vote": "Deng bide",
  "poll.voted": "Te dengê xwe da vê bersivê",
  "poll.votes": "{votes, plural, one {# deng} other {# deng}}",
  "poll_button.add_poll": "Rapirsîyek zêde bike",
  "poll_button.remove_poll": "Rapirsî yê rake",
  "privacy.change": "Taybetiya şandiyê biguherîne",
  "privacy.direct.short": "Payemên taybet",
  "privacy.private.long": "Tenê şopînerên te",
  "privacy.private.short": "Şopîner",
  "privacy.public.short": "Gelemperî",
  "privacy_policy.last_updated": "Rojanekirina dawî {date}",
  "privacy_policy.title": "Politîka taybetiyê",
  "refresh": "Nû bike",
  "relative_time.days": "{number}r",
  "relative_time.full.days": "{number, plural, one {# roj} other {# roj}} berê",
  "relative_time.full.hours": "{number, plural, one {# demjimêr} other {# demjimêr}} berê",
  "relative_time.full.just_now": "hema niha",
  "relative_time.full.minutes": "{number, plural, one {# xulek} other {# xulek}} berê",
  "relative_time.full.seconds": "{number, plural, one {# çirke} other {# çirke}} berê",
  "relative_time.hours": "{number}d",
  "relative_time.just_now": "niha",
  "relative_time.minutes": "{number}x",
  "relative_time.seconds": "{number}ç",
  "relative_time.today": "îro",
  "reply_indicator.cancel": "Dev jê berde",
  "report.block": "Asteng bike",
  "report.block_explanation": "Tu yê şandiyên wan nebînî. Ew ê nikaribin şandiyên te bibînin an jî te bişopînin. Ew ê bizanibin ku ew hatine astengkirin.",
  "report.categories.other": "Yên din",
  "report.categories.spam": "Nexwestî (Spam)",
  "report.categories.violation": "Naverok yek an çend rêbazên rajekar binpê dike",
  "report.category.subtitle": "Baştirîn lihevhatin hilbijêre",
  "report.category.title": "Ji me re bêje ka çi diqewime bi vê {type} re",
  "report.category.title_account": "profîl",
  "report.category.title_status": "şandî",
  "report.close": "Qediya",
  "report.comment.title": "Tiştek din heye ku tu difikirî ku divê em zanibin?",
  "report.forward": "Biçe bo {target}",
  "report.forward_hint": "Ajimêr ji rajekareke din e. Tu kopîyeka anonîm ya raporê bişînî wir jî?",
  "report.mute": "Bêdeng bike",
  "report.mute_explanation": "Tê yê şandiyên wan nebînî. Ew hin jî dikarin te bişopînin û şandiyên te bibînin û wê nizanibin ku ew hatine bêdengkirin.",
  "report.next": "Pêş",
  "report.placeholder": "Şiroveyên zêde",
  "report.reasons.dislike": "Ez jê hez nakim",
  "report.reasons.dislike_description": "Ew ne tiştek e ku tu dixwazî bibînî",
  "report.reasons.other": "Tiştekî din e",
  "report.reasons.other_description": "Pirsgirêk di kategoriyên din de cih nagire",
  "report.reasons.spam": "Ew spam e",
  "report.reasons.spam_description": "Girêdanên xerab, tevlêbûna sexte, an jî bersivên dubarekirî",
  "report.reasons.violation": "Ew rêzikên rajekar binpê dike",
  "report.reasons.violation_description": "Tu dizanî ku ew rêzikên taybetiyê binpê dike",
  "report.rules.subtitle": "Hemûyên ku têne sepandin hibijêre",
  "report.rules.title": "Kîjan rêzik têne binpêkirin?",
  "report.statuses.subtitle": "Hemûyên ku têne sepandin hibijêre",
  "report.statuses.title": "Tu şandiyên ku vê ragihandinê piştgirî dikin hene?",
  "report.submit": "Bişîne",
  "report.target": "Ragihandin {target}",
  "report.thanks.take_action": "Li vir vebijêrkên te hene ji bo kontrolkirina tiştê ku tu li se Mastodon dibînî:",
  "report.thanks.take_action_actionable": "Dema ku em vê yekê dinirxînin, tu dikarî li dijî @{name} tedbîran bigirî:",
  "report.thanks.title": "Tu naxwazî vê bibînî?",
  "report.thanks.title_actionable": "Spas ji bo ragihandina te, em ê binirxînin.",
  "report.unfollow": "@{name} neşopîne",
  "report.unfollow_explanation": "Tê vê ajimêrê dişopînî. Ji bo ku êdî şandiyên wan di rojeva xwe de nebînî, wan neşopîne.",
  "report_notification.attached_statuses": "{count, plural,one {{count} şandî} other {{count} şandî}} pêvekirî",
  "report_notification.categories.other": "Ên din",
  "report_notification.categories.spam": "Nexwestî (Spam)",
  "report_notification.categories.violation": "Binpêkirina rêzîkê",
  "report_notification.open": "Ragihandinê veke",
  "search.no_recent_searches": "Lêgerînên dawî tune ne",
  "search.placeholder": "Bigere",
  "search.quick_action.account_search": "Profîlên lihevhatî {x}",
  "search.quick_action.go_to_account": "Biçe profîla {x}",
  "search.quick_action.go_to_hashtag": "Biçe hashtaga {x}",
  "search.quick_action.open_url": "Girêdanê di Mastodon de veke",
  "search.quick_action.status_search": "Şandiyên lihevhatî {x}",
  "search.search_or_paste": "Bigere yan jî girêdanê pêve bike",
  "search_popout.quick_actions": "Çalakiyên bilez",
  "search_popout.recent": "Lêgerînên dawî",
  "search_results.accounts": "Profîl",
  "search_results.all": "Hemû",
  "search_results.hashtags": "Hashtag",
  "search_results.statuses": "Şandî",
  "server_banner.about_active_users": "Kesên ku di van 30 rojên dawî de vê rajekarê bi kar tînin (Bikarhênerên Çalak ên Mehane)",
  "server_banner.active_users": "bikarhênerên çalak",
  "server_banner.administered_by": "Tê birêvebirin ji aliyê:",
  "server_banner.server_stats": "Amarên rajekar:",
  "sign_in_banner.create_account": "Ajimêr biafirîne",
  "sign_in_banner.sign_in": "Têkeve",
  "sign_in_banner.sso_redirect": "Têkeve yan tomar bibe",
  "status.admin_account": "Ji bo @{name} navrûya venihêrtinê veke",
  "status.admin_domain": "Navrûya bikarhêneriyê ji bo {domain} veke",
  "status.admin_status": "Vê şandîyê di navrûya venihêrtinê de veke",
  "status.block": "@{name} asteng bike",
  "status.bookmark": "Şûnpel",
  "status.cancel_reblog_private": "Bilind neke",
  "status.cannot_reblog": "Ev şandî nayê bilindkirin",
  "status.copy": "Girêdanê jê bigire bo weşankirinê",
  "status.delete": "Jê bibe",
  "status.detailed_status": "Dîtina axaftina berfireh",
  "status.direct": "Bi taybetî qale @{name} bike",
  "status.direct_indicator": "Payemên taybet",
  "status.edit": "Serrast bike",
  "status.edited_x_times": "{count, plural, one {{count} car} other {{count} car}} hate serrastkirin",
  "status.filter": "Vê şandiyê parzûn bike",
  "status.history.created": "{name} {date} afirand",
  "status.history.edited": "{name} {date} serrast kir",
  "status.load_more": "Bêtir bar bike",
  "status.media_hidden": "Medya veşartî ye",
  "status.mention": "Qal @{name} bike",
  "status.more": "Bêtir",
  "status.mute": "@{name} bêdeng bike",
  "status.mute_conversation": "Axaftinê bêdeng bike",
  "status.open": "Vê şandiyê berferh bike",
  "status.pin": "Li ser profîlê derzî bike",
  "status.read_more": "Bêtir bixwîne",
  "status.reblog": "Bilind bike",
  "status.reblogged_by": "{name} bilind kir",
  "status.reblogs.empty": "Kesekî hin ev şandî bilind nekiriye. Gava kesek bilind bike, ew ên li vir werin xuyakirin.",
  "status.redraft": "Jê bibe & ji nû ve reşnivîs bike",
  "status.remove_bookmark": "Şûnpêlê jê rake",
  "status.replied_to": "Bersiv da {name}",
  "status.reply": "Bersivê bide",
  "status.replyAll": "Mijarê bibersivîne",
  "status.report": "@{name} ragihîne",
  "status.sensitive_warning": "Naveroka hestiyarî",
  "status.share": "Parve bike",
  "status.show_less_all": "Ji bo hemîyan kêmtir nîşan bide",
  "status.show_more_all": "Bêtir nîşan bide bo hemûyan",
  "status.show_original": "A resen nîşan bide",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Wergerîne",
  "status.translated_from_with": "Ji {lang} hate wergerandin bi riya {provider}",
  "status.unmute_conversation": "Axaftinê bêdeng neke",
  "status.unpin": "Şandiya derzîkirî ji profîlê rake",
  "subscribed_languages.lead": "Tenê şandiyên bi zimanên hilbijartî wê di rojev û demnameya te de wê xuya bibe û piştî guhertinê. Ji bo wergirtina şandiyan di hemû zimanan de ne yek hilbijêre.",
  "subscribed_languages.save": "Guhertinan tomar bike",
  "subscribed_languages.target": "Zimanên beşdarbûyî biguherîne ji bo {target}",
  "tabs_bar.home": "Rûpela sereke",
  "tabs_bar.notifications": "Agahdarî",
  "time_remaining.days": "{number, plural, one {# roj} other {# roj}} maye",
  "time_remaining.hours": "{number, plural, one {# demjimêr} other {# demjimêr}} maye",
  "time_remaining.minutes": "{number, plural, one {# xulek} other {# xulek}} maye",
  "time_remaining.moments": "Demên mayî",
  "time_remaining.seconds": "{number, plural, one {# çirke} other {# çirke}} maye",
  "trends.counter_by_accounts": "{count, plural, one {{counter} kes} other {{counter} kes}} berî {days, plural, one {roj} other {{days} roj}}",
  "trends.trending_now": "Rojev",
  "ui.beforeunload": "Ger ji Mastodonê veketi wê reşnivîsa te jî winda bibe.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}H",
  "upload_area.title": "Ji bo barkirinê kaş bike û deyne",
  "upload_button.label": "Wêne, vîdeoyek an jî pelê dengî tevlî bike",
  "upload_error.limit": "Sînora barkirina pelan derbas bû.",
  "upload_error.poll": "Di rapirsîyan de mafê barkirina pelan nayê dayîn.",
  "upload_form.edit": "Serrast bike",
  "upload_progress.label": "Tê barkirin...",
  "upload_progress.processing": "Kar tê kirin…",
  "video.close": "Vîdyoyê bigire",
  "video.download": "Pelê daxe",
  "video.exit_fullscreen": "Ji dîmendera tijî derkeve",
  "video.expand": "Vîdyoyê berferh bike",
  "video.fullscreen": "Dimendera tijî",
  "video.hide": "Vîdyo veşêre",
  "video.pause": "Rawestîne",
  "video.play": "Vêxe"
}
